import { useEffect, useState } from "react";

export interface ViewportInfo {
  isTablet: boolean;
  touchTarget: number;
  shellMax: number;
}

export function useViewport(): ViewportInfo {
  const [info, setInfo] = useState<ViewportInfo>(() => compute());

  useEffect(() => {
    const onResize = () => setInfo(compute());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return info;
}

function compute(): ViewportInfo {
  if (typeof window === "undefined") {
    return { isTablet: false, touchTarget: 44, shellMax: 430 };
  }
  const minDim = Math.min(window.innerWidth, window.innerHeight);
  const isTablet = minDim >= 768;
  return {
    isTablet,
    touchTarget: isTablet ? 60 : 44,
    shellMax: isTablet ? 720 : 430,
  };
}
